module.exports = __webpack_public_path__ + "img/symbol_9.582c5aea.png";